import { ContentLayout } from '@/components/layout'
import { MarkdownFromUrl } from '@/components/ui'
import { attr, html, Value } from '@tempots/dom'

export interface MarkdownPageOptions {
  url: Value<string>
}

export function MarkdownPage({ url }: MarkdownPageOptions) {
  return ContentLayout(
    {},
    // Header
    html.div(
      attr.class('text-center mb-8'),
      html.h1(
        attr.class('text-2xl sm:text-3xl font-bold text-gray-900'),
        'Privacy Policy'
      ),
      html.p(
        attr.class('mt-2 text-sm text-gray-500'),
        'Last updated: December 2025'
      )
    ),
    // Content
    html.div(
      attr.class('prose prose-gray max-w-none'),
      MarkdownFromUrl({ url })
    )
  )
}
